import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'gu',
  months: [
    'જાન્યુઆરી',
    'ફેબ્રુઆરી',
    'માર્ચ',
    'એપ્રિલ',
    'મે',
    'જૂન',
    'જુલાઈ',
    'ઑગસ્ટ',
    'સપ્ટેમ્બર',
    'ઑક્ટોબર',
    'નવેમ્બર',
    'ડિસેમ્બર',
  ],
  monthsShort: ['જાન્યુ', 'ફેબ્રુ', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઈ', 'ઑગસ્ટ', 'સપ્ટે', 'ઑક્ટો', 'નવે', 'ડિસે'],
  weekdays: ['રવિવાર', 'સોમવાર', 'મંગળવાર', 'બુધવાર', 'ગુરુવાર', 'શુક્રવાર', 'શનિવાર'],
  weekdaysMin: ['રવિ', 'સોમ', 'મંગળ', 'બુધ', 'ગુરુ', 'શુક્ર', 'શનિ'],
  weekdaysShort: ['રવિ', 'સોમ', 'મંગળ', 'બુધ', 'ગુરુ', 'શુક્ર', 'શનિ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s વર્ષ પહેલાં', other: '%s વર્ષ પહેલાં' },
    M: { one: '%s મહિના પહેલાં', other: '%s મહિના પહેલાં' },
    w: { one: '%s અઠ. પહેલાં', other: '%s અઠ. પહેલાં' },
    d: { one: '%s દિવસ પહેલાં', other: '%s દિવસ પહેલાં' },
    h: { one: '%s કલાક પહેલાં', other: '%s કલાક પહેલાં' },
    m: { one: '%s મિનિટ પહેલાં', other: '%s મિનિટ પહેલાં' },
    s: { one: '%s સેકંડ પહેલાં', other: '%s સેકંડ પહેલાં' },
  },
  future: {
    y: { one: '%s વર્ષમાં', other: '%s વર્ષમાં' },
    M: { one: '%s મહિનામાં', other: '%s મહિનામાં' },
    w: { one: '%s અઠ. માં', other: '%s અઠ. માં' },
    d: { one: '%s દિવસમાં', other: '%s દિવસમાં' },
    h: { one: '%s કલાકમાં', other: '%s કલાકમાં' },
    m: { one: '%s મિનિટમાં', other: '%s મિનિટમાં' },
    s: { one: '%s સેકંડમાં', other: '%s સેકંડમાં' },
  },
  abbr: {
    y: { one: '%s વર્ષ', other: '%s વર્ષ' },
    M: { one: '%s મ', other: '%s મ' },
    w: { one: '%s અ.', other: '%s અ' },
    d: { one: '%s દિ', other: '%s દિ' },
    h: { one: '%s ક', other: '%s ક' },
    m: { one: '%s મિ', other: '%s મિ' },
    s: { one: '%s સે', other: '%s સે' },
  },
  justNow: 'હજુ હમણાં જ',
  yesterday: 'ગઈકાલે',
  today: 'આજે',
  tomorrow: 'આવતીકાલે',
  weekStart: 0,
};
const localeName: LocaleName = 'gu';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
